@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.selectModeDropdown {
  opacity: 0;
  height: 0;
}

.inlineDropdownPaper {
  margin-bottom: 0;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  width: 100%;
}

.inlineDropdownInput {
  border-bottom: solid hevo-toolkit-variables.$border-width hevo-toolkit-variables.$divider-color !important;
  width: 100%;
}
